module.exports = __webpack_public_path__ + "media/images/btn_confirm_booking-849f6156fee9a0b9ddd51ee033442c01.gif";